module.exports = __webpack_public_path__ + "static/media/amina.c2e4fd20.jpg";